module.exports = __webpack_public_path__ + "static/img/bankbanner.1a163aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bankbanner.jpg
// module id = 9HYR
// module chunks = 0